export const getOrderDetails = ({ state }) =>
  state.totalOrderDetails.orderDetails;
export const getCartDetails = ({ state }) =>
  state.totalOrderDetails.cartDetails;
export const getInventoryDetails = ({ state }) =>
  state.totalOrderDetails.inventoryDetails;
